var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "79-users",
    id: "_79-users"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 16,
    cy: 13,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23,28A7,7,0,0,0,9,28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24,14a5,5,0,1,0-4-8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25,24h6a7,7,0,0,0-7-7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,6a5,5,0,1,0-4,8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8,17a7,7,0,0,0-7,7H7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/usersIcon.b138d7de346644fdf3bf6016ad3c68c0.svg";
export { ForwardRef as ReactComponent };